import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { CreditWorthiness } from './CreditWorthiness';
import { OfferMessages } from './OfferMessages';
import { InfoSidebarModal } from '../../../InfoSidebarModal';
import type { AcceptedOfferSource, OfferSource } from '../types';

type Props = {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
} & (AcceptedOfferSource | OfferSource);

export const OfferExtraInfoDialog: React.FC<Props> = (props) => {
    const { isOpen, setIsOpen } = props;
    const { t } = useTranslation();
    const isEuropace = props.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE;

    return (
        <InfoSidebarModal
            title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
            open={isOpen}
            onClose={() => setIsOpen(false)}
            testId="offerExtraInfoDialog"
        >
            <OfferMessages
                feasibilityStatus={isEuropace ? props.offer?.machbarkeit?.status : undefined}
                machbarkeitMessages={isEuropace ? props.offer?.machbarkeit?.messages ?? [] : []}
                vollstaendigkeitMessages={isEuropace ? props.offer?.vollstaendigkeit?.messages ?? [] : []}
            />
            <CreditWorthiness householdBudget={isEuropace ? props.offer?.bonitaetsrechnung : undefined} />
        </InfoSidebarModal>
    );
};
